import { CHAIN_ID } from '@31third/common';

export function getIconForChainId(
  chainId: string | undefined,
): string | undefined {
  switch (chainId) {
    case CHAIN_ID.ETHEREUM:
      return 'ethereum.svg';
    case CHAIN_ID.POLYGON:
      return 'polygon.svg';
    case CHAIN_ID.OPTIMISM:
      return 'optimism.svg';
    case CHAIN_ID.BSC:
      return 'bsc.svg';
    case CHAIN_ID.ARBITRUM_ONE:
      return 'arbitrum.svg';
    case CHAIN_ID.BASE:
      return 'base.svg';
    case CHAIN_ID.ETHEREUM_31THIRD_FORK:
    case CHAIN_ID.ETHEREUM_LOCAL_FORK:
    case CHAIN_ID.POLYGON_31THIRD_FORK:
    case CHAIN_ID.POLYGON_LOCAL_FORK:
    case CHAIN_ID.OPTIMISM_31THIRD_FORK:
    case CHAIN_ID.OPTIMISM_LOCAL_FORK:
      return 'testnet.svg';
    default:
      return undefined;
  }
}
